var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHoverNotice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 15.9844L20.0156 18V18.9844H3.98438V18L6 15.9844V11.0156C6 9.45312 6.39062 8.09375 7.17188 6.9375C7.98438 5.78125 9.09375 5.03125 10.5 4.6875V3.98438C10.5 3.57812 10.6406 3.23438 10.9219 2.95312C11.2031 2.64062 11.5625 2.48438 12 2.48438C12.4375 2.48438 12.7969 2.64062 13.0781 2.95312C13.3594 3.23438 13.5 3.57812 13.5 3.98438V4.6875C14.9062 5.03125 16 5.78125 16.7812 6.9375C17.5938 8.09375 18 9.45312 18 11.0156V15.9844ZM12 21.9844C11.4375 21.9844 10.9531 21.7969 10.5469 21.4219C10.1719 21.0156 9.98438 20.5469 9.98438 20.0156H14.0156C14.0156 20.5469 13.8125 21.0156 13.4062 21.4219C13 21.7969 12.5312 21.9844 12 21.9844Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoverNotice);
export default __webpack_public_path__ + "static/media/HoverNotice.1f94aea4de2a8cf160cb6772ef314bcc.svg";
export { ForwardRef as ReactComponent };